
import apiClient from './api';

export const authService = {
  // Login user
  login(credentials) {
    return apiClient.post('/auth/login/', credentials);
  },
  
  // Register new user
  register(userData) {
    return apiClient.post('/auth/register/', userData);
  },
  
  // Logout user
  logout() {
    return apiClient.post('/auth/logout/');
  },
  
  // Get current user profile
  getUserProfile() {
    return apiClient.get('/auth/profile/');
  },
  
  // Check if user is logged in
  isLoggedIn() {
    return !!localStorage.getItem('token');
  },
  
  // Set auth token for API calls
  setAuthToken(token) {
    if (token) {
      apiClient.defaults.headers.common['Authorization'] = `Token ${token}`;
      localStorage.setItem('token', token);
    } else {
      delete apiClient.defaults.headers.common['Authorization'];
      localStorage.removeItem('token');
    }
  },
    
  // Initialize auth from localStorage (call this when your app starts)
  initializeAuth() {
    const token = localStorage.getItem('token');
    if (token) {
      this.setAuthToken(token);
      return true;
    }
    return false;
  }
};

export default authService;